import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { combineLatest, of, ReplaySubject, Subscription } from 'rxjs';
import { delay, map, take } from 'rxjs/operators';
import { SessionService } from 'src/app/lib/shared/services/session.service';

@Component({
  selector: 'app-nextcloud-path-navigator',
  templateUrl: './nextcloud-path-navigator.component.html',
  styleUrls: ['./nextcloud-path-navigator.component.css']
})
export class NextcloudPathNavigatorComponent implements OnDestroy, OnInit {

  private _body = new ReplaySubject<ElementRef<HTMLDivElement>>();
  body$ = this._body.asObservable();
  @ViewChild('body', { static: true, read: ElementRef }) public set body(body){
    this._body.next(body);
  }

  private _pathArray = new ReplaySubject<string[]>();
  relativePathArray$ = combineLatest([this._pathArray, this._sessionService.getSettingByName('nextcloud-username')])
    .pipe(map(([path, nextcloudUsername]) => {
      if(nextcloudUsername === null) return [];
      path = path.filter(y => typeof(y) === 'string' && y.trim() !== '');
      let index = path.indexOf(nextcloudUsername.stgvalue);
      if(index === -1) return path;
      if(index === (path.length - 1)) return [];
      return path.slice(index + 1);
    }));
  @Input() set pathArray(pathArray: string[]){
    this._pathArray.next(pathArray);
  }

  @Input() enableNavigation: boolean = false;

  @Output() pathChanged: EventEmitter<string[]> = new EventEmitter();

  private _subscriptions: Subscription[] = [];

  constructor(private _sessionService: SessionService) { }

  navigateToRoot(){
    if(!this.enableNavigation) return;
    this.pathChanged.next([]);
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      combineLatest([this.body$, this.relativePathArray$]).pipe(delay(20)).subscribe(([ref, path]) => ref.nativeElement.scrollTo({ left: ref.nativeElement.scrollWidth }))
    ]);
  }

  segmentClick(index: number){
    if(!this.enableNavigation) return;
    this.relativePathArray$.pipe(take(1)).subscribe((segments) => this.pathChanged.next(segments.slice(0, index+1)));
  }

}
